<template>
  <div class="ioRecord">
    <div class="right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
         
            <el-select
              filterable
              clearable
              v-model="search.parkingId"
              placeholder="请选择道路"
              style="width: 160px"
            >
              <el-option
                v-for="item in parkingList"
                :key="item.parkingId"
                :label="item.parkingName"
                :value="item.parkingId"
              >
              </el-option>
            </el-select>
          </div>
          <div class="form-group">
         
            <el-input placeholder="订单编号" v-model="search.no" style="width: 120px"> </el-input>
          </div>
          <div class="form-group">
            
            <el-input placeholder="车牌号码" v-model="search.plateNumber" style="width: 120px">
            </el-input>
          </div>
          
          <div class="form-group">
            
            <el-date-picker
              clearable
              v-model="search.payTimeRange"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="支付开始时间"
              end-placeholder="支付结束时间"
              :default-time="['00:00:00', '23:59:59']"
              style="width: 360px"
            ></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
               :disabled="loading">
              <i v-if="loading" class="el-icon-loading"></i>
              {{ loading ? "查询中..." : "查询" }}
            </button>
            </span>
            <span class="download_btn">
              <button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
                id="export_btn"
                :disabled="exportLoading"
              >
                <i v-if="exportLoading" class="el-icon-loading"></i>
                {{ exportLoading ? "导出中..." : "导出" }}
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="total-amount-box">
        <span>总金额：</span>
        <span class="amount-value">¥ {{ totalAmount }}</span>
      </div>
      <template>
        <div v-show="showList" class="list-right">
          <el-table v-loading="loading" element-loading-text="加载中..."
            ref="table"
            border
            :data="tableListData"
            height="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
            <el-table-column
              show-overflow-tooltip
              label="订单号"
              prop="no"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="车牌"
              prop="plateNumber"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="道路"
              prop="parkingName"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="金额"
              prop="realPay"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="支付时间"
              prop="payTime"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="开始时间"
              prop="startTime"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="结束时间"
              prop="endTime"
            ></el-table-column>
          </el-table>
        </div>
      </template>
    </div>
    <Page v-show="showList" v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { getRentMonthOrderparking, fetchParkigList } from "@/api/url";
import Page from "../../commons/page";
export default {
  data() {
    return {
      loading: false,
      exportLoading: false,
      moduleName: "property",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      groupList: [],
      tableListData: [],
      tableListDataTitle: [],
      showList: true,
      showChart: false,
      parkingList: [],
      search: {
        pageSize: 10,
        pageNumber: 1,
        no: "",
        plateNumber: "",
        parkingId: "",
        payTimeRange: [],
      },
      totalAmount: 0,
      value4: "",
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    getParkingList() {
      return this.$get(fetchParkigList()).then((res) => {
        if (res.status === 200) this.parkingList = res.data;
      });
    },
    getTimeParams() {
      const [beginTime = "", endTime = ""] = this.search.payTimeRange || [];
      return { beginTime, endTime };
    },
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    fetchTotalAmount() {
      const { beginTime, endTime } = this.getTimeParams();
      this.$get("/api/parking/rentMonthOrder/totalAmount", {
        no: this.search.no,
        plateNumber: this.search.plateNumber,
        parkingIds: this.search.parkingId,
        beginTime,
        endTime,
      }).then((data) => {
        if (data.status === 200) {
          this.totalAmount = data.data || 0;
        }
      });
    },
    tableList: function (curPage) {
      this.loading = true;
      const { beginTime, endTime } = this.getTimeParams();
      var _this = this;
      this.$get(getRentMonthOrderparking(), {
        page: curPage,
        limit: this.search.pageSize,
        no: this.search.no,
        plateNumber: this.search.plateNumber,
        parkingIds: this.search.parkingId,
        beginTime,
        endTime,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.loading = false;
      });
      this.fetchTotalAmount();
},
    searchList: function () {
      if (this.loading) return;
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    downloadData() {
      if (this.exportLoading) return;
      this.exportLoading = true;
      const { beginTime, endTime } = this.getTimeParams();
      this.$downloadFileRequest(
        "/api/parking/rentMonthOrder/export",
        {
          no: this.search.no,
          plateNumber: this.search.plateNumber,
          parkingIds: this.search.parkingId,
          beginTime,
          endTime,
        },
        "月租车续费记录"
      ).finally(() => {
        this.exportLoading = false;
      });
    },
  },
  components: {
    Page,
  },
  mounted: function () {
    this.getParkingList().then(() => {
      this.searchList();
    });
  },
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px 10px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
  width: 16px;
}
.switch-info {
  display: inline-block;
  margin-left: 5px;
  width: 16px;
}
.total-amount-box {
  background: #f9f9fb;
  padding: 10px 20px;
  font-size: 14px;
  color: #333;
}
.amount-value {
  color: #f56c6c;
  font-weight: bold;
  font-size: 16px;
}
.show-list {
  height: 500px;
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
.download_btn {
  display: inline-block;
  margin-left: 15px;
}
</style>
